var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBankroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.317,
    height: 101.527,
    viewBox: "0 0 105.317 101.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-bankroll",
    transform: "translate(-229.661 -861.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-bankroll-2",
    "data-name": "icon-bankroll",
    d: "M78.463,33.411c9.421,16.7,16.9,34.853,11.333,44.166-5.5,9.314-24.128,9.854-42.022,9.274C29.947,86.2,12.783,84.431,5.094,73.8c-7.757-10.7-6.1-30.252,2.3-46.3S31.029-1.147,44.289.166C57.616,1.48,69.042,16.715,78.463,33.411Z",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 244.679, 861.825)",
    fill: "#b23130",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    id: "cost",
    transform: "translate(265 888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14662",
    "data-name": "Path 14662",
    d: "M191.3,165.017a1.151,1.151,0,0,0-.415-.014,2.75,2.75,0,0,1-2.432-2.727,1.209,1.209,0,1,0-2.419,0,5.174,5.174,0,0,0,3.8,4.982v1.209a1.209,1.209,0,0,0,2.419,0v-1.136a5.165,5.165,0,0,0-1.058-10.22,2.746,2.746,0,1,1,2.746-2.746,1.209,1.209,0,1,0,2.419,0,5.174,5.174,0,0,0-4.107-5.056v-1.1a1.209,1.209,0,1,0-2.419,0v1.175a5.164,5.164,0,0,0,1.361,10.146,2.744,2.744,0,0,1,.1,5.487Zm0,0",
    transform: "translate(-173.665 -124.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14663",
    "data-name": "Path 14663",
    d: "M104.195,124.03a17.538,17.538,0,1,0,17.538-17.538A17.538,17.538,0,0,0,104.195,124.03Zm17.538-15.119a15.119,15.119,0,1,1-15.119,15.119A15.119,15.119,0,0,1,121.733,108.911Zm0,0",
    transform: "translate(-104.195 -90.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14665",
    "data-name": "Path 14665",
    d: "M214.622,12.7V1.209a1.209,1.209,0,0,0-2.419,0V12.7a1.209,1.209,0,0,0,2.419,0Zm0,0",
    transform: "translate(-195.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14666",
    "data-name": "Path 14666",
    d: "M274.622,46.652V41.209a1.209,1.209,0,0,0-2.419,0v5.443a1.209,1.209,0,0,0,2.419,0Zm0,0",
    transform: "translate(-246.803 -33.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14667",
    "data-name": "Path 14667",
    d: "M154.622,46.652V41.209a1.209,1.209,0,1,0-2.419,0v5.443a1.209,1.209,0,1,0,2.419,0Zm0,0",
    transform: "translate(-144.945 -33.953)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBankroll);
export default __webpack_public_path__ + "static/media/icon-bankroll.c2b451af3e92c298f3529a59e482d644.svg";
export { ForwardRef as ReactComponent };